import { Link } from 'react-router-dom';
import type { Article } from '@/mocks/data';

interface Props {
  article: Article;
}

export default function ArticleCard({ article }: Props) {
  const categoryLabel =
    article.category === 'latest-address' ? '最新地址' :
    article.category === 'access-guide' ? '访问指南' :
    article.category === 'popular-recommend' ? '热门推荐' :
    article.category === 'new-releases' ? '最新上架' :
    article.category === 'genres' ? '分类浏览' : '帮助中心';

  return (
    <Link
      to={`/article/${article.slug}`}
      className="group block bg-background-50 rounded-lg border border-background-200/70 overflow-hidden hover:border-primary-200 transition-all duration-300 cursor-pointer"
    >
      <div className="relative w-full h-48 overflow-hidden">
        <img
          src={article.imageUrl}
          alt={article.title}
          title={article.title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute top-3 left-3">
          <span className="px-2.5 py-1 bg-primary-500 text-background-50 text-xs font-medium rounded-md">
            {categoryLabel}
          </span>
        </div>
      </div>
      <div className="p-4 md:p-5">
        <h3 className="font-heading font-semibold text-foreground-950 text-base mb-2 group-hover:text-primary-600 transition-colors line-clamp-2">
          {article.title}
        </h3>
        <p className="text-foreground-600 text-sm leading-relaxed line-clamp-2 mb-3">
          {article.excerpt}
        </p>
        <div className="flex items-center justify-between text-xs text-foreground-400">
          <span className="flex items-center gap-1">
            <i className="ri-calendar-line"></i>
            {article.date}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-time-line"></i>
            {article.readTime}
          </span>
        </div>
      </div>
    </Link>
  );
}